import React from 'react';
import { isString } from '../../../../util';
import KcClient from '../../../../keycloak/client';
import { scope } from '../../../../i18n';
import { useTranslation } from 'react-i18next';
import { AuthDataProvider } from '..';
import { ServiceProvider } from '../../../../service';

import { Progress, Failure } from '../../../core/layout/interstitial'

export function SuspenseDefault() {
	return null;
}

export function SuspenseProgress({t}) {
	return <Progress message={t("","")} />;
}

export function FailedDefault({t}) {
    return <Failure message={t()} />;
}

export default function Authenticator({ enforce, ...props}) {
	return enforce 
		? <AuthenticatorEnforced mode={enforce} {...props}/>
		: <AuthenticatorUnenforced {...props}/>
}

const MODE_REQUIRED = 'required';
const MODE_OPTIONAL = 'optional';

export function AuthenticatorEnforced({ mode, Suspense, Failed, children, config, i18n:i18nDesc={} }) {
	mode = isString(mode) ? mode : MODE_REQUIRED;
	const i18n = useTranslation(i18nDesc.ns || 'common');
	const [state, setState] = React.useState({authData:null, suspense:true, authServices:null});

	React.useEffect(() => {
		let cancelled = false
		const auth = async () => {
			try {
				const kcInst = KcClient(config);
				const authData = await kcInst.auth(mode === MODE_OPTIONAL);
				if(cancelled)return;
				const compResult = { authenticator:'keycloak', ...authData };
				setState({authData:compResult, suspense:false, authServices:{init:() => ({
					Login:async (_, { setResult }) => {
						const authData = await kcInst.auth();
						setResult(authData);
					},
					Logout:async(_, { setResult }) => {
						await kcInst.logout();
						setResult(true);
					},
					Manage:async(_, { setResult }) => {
						await kcInst.manage();
						setResult(true);
					}
				})}});
			} catch (error) {
				setState({authData:null, suspense:false, authServices:null});
				
			}
		}
		auth();
	}, []); //eslint-disable-line react-hooks/exhaustive-deps

	return state.suspense 
		? (Suspense || <SuspenseDefault t={scope(i18n,'keycloak.suspense')}/>) 
		: (state.authData || mode === MODE_OPTIONAL) 
			? (<ServiceProvider services={state.authServices && state.authServices.init}><AuthDataProvider value={state.authData}>{children}</AuthDataProvider></ServiceProvider>)
			: (Failed || <FailedDefault t={scope(i18n,'keycloak.failed')}/>)
}

export function AuthenticatorUnenforced({ children, config }) {
	const authServices = {init:() => ({
		Login:async (_, { setResult }) => {
			const kcInst = KcClient(config);
			const authData = await kcInst.auth();
			setResult(authData);
		},
		Logout:async(_, { setResult }) => {
			const kcInst = KcClient(config);
			await kcInst.logout();
			setResult(true);
		}
	})}
	return (
		<ServiceProvider services={authServices && authServices.init}>
			{children}
		</ServiceProvider>
	);
}